import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { BarChart3 } from 'lucide-react';
import { useSessionStore } from '@renderer/store/useSessionStore';
import { esWeb } from '@renderer/lib/entorno';
import { activarMonitoreo, instalarMonitoreo, verPantalla } from '@renderer/lib/monitoreoUso';

const CLAVE_AVISO = 'aviso-monitoreo-visto';

/**
 * Sprint 161 — Engancha el monitoreo de uso a la navegación y le avisa a la dueña, una vez.
 *
 * Lo que dice el aviso es exactamente lo que se guarda: qué pantallas se usan y con qué puesto
 * (dueño, caja, mesero), nunca quién ni lo que se escribe.
 *
 * El aviso no es un trámite legal: sus empleados quedan medidos y lo correcto es decírselo
 * (decisión de José del 18/10/2026). Va una sola vez por equipo y sólo al dueño, con las palabras
 * acordadas.
 */
export function MonitoreoUso() {
  const location = useLocation();
  const sesion = useSessionStore((s) => s.sesion);
  const [avisar, setAvisar] = useState(false);

  useEffect(() => {
    instalarMonitoreo();
  }, []);

  useEffect(() => {
    activarMonitoreo(Boolean(sesion));
    if (sesion?.rol === 'dueño' && esWeb() && !localStorage.getItem(CLAVE_AVISO)) setAvisar(true);
  }, [sesion]);

  useEffect(() => {
    if (sesion) verPantalla(location.pathname);
  }, [location.pathname, sesion]);

  if (!avisar) return null;
  return (
    // Arriba a la derecha: abajo lo tapaba la franja de la impresora y no se podía tocar "Entendido"
    // (visto en el recorrido con Playwright).
    <div className="fixed right-4 top-20 z-[70] flex max-w-sm items-start gap-3 rounded-xl border border-slate-300 bg-white p-4 shadow-lg" role="status">
      <BarChart3 className="mt-0.5 h-5 w-5 shrink-0 text-primary" aria-hidden />
      <div>
        <p className="text-sm text-slate-800">
          Para mejorar el sistema, registramos qué pantallas se usan. <strong>No guardamos lo que escribes.</strong>
        </p>
        <button
          className="mt-2 min-h-[44px] rounded-lg bg-primary px-4 text-sm font-semibold text-white hover:bg-primary/90"
          onClick={() => {
            localStorage.setItem(CLAVE_AVISO, new Date().toISOString());
            setAvisar(false);
          }}
        >
          Entendido
        </button>
      </div>
    </div>
  );
}
